import { IStore } from '../../store';
import { jobSelectors } from '../../_core/job';
import { IBFL1Store } from './@types';
import { EBFL1Actions } from './actions';

const bfl1Selectors = {
    _getStore(store: IStore) {
        return store.app.bfl1;
    },
    getHistoryList(store: IBFL1Store) {
        return store.records.ids.map((id) => ({
            ...store.records.byIds[id],
        }));
    },
    getFilter(store: IBFL1Store) {
        return {
            ...store.filter,
            shownRecords: store.filter.shownRecords
                ? store.filter.shownRecords
                : 'ALL',
        };
    },
    jobToLoadHistory(store: IBFL1Store) {
        return jobSelectors.getJobStatus(store, EBFL1Actions.HISTORY_LOAD);
    },
};
export default bfl1Selectors;
